export default __webpack_public_path__ + "static/media/eco-home-bg.80d78fbc.jpeg";